var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFullIconLargeActive = function SvgFullIconLargeActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 56.25,
    viewBox: "0 0 100 56.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "full-icon-large-active",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "White_Box",
    "data-name": "White Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M685.032,535.343h-99v-55.25h99Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M586.532,480.592v54.25h98v-54.25h-98m-1-1h100v56.25h-100Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#024"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box",
    "data-name": "Grey Box",
    d: "M589.532,483.592h92v48.25h-92Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#024"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFullIconLargeActive);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iNTYuMjUiIHZpZXdCb3g9IjAgMCAxMDAgNTYuMjUiPgogIDxnIGlkPSJmdWxsLWljb24tbGFyZ2UtYWN0aXZlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj4KICAgIDxnIGlkPSJXaGl0ZV9Cb3giIGRhdGEtbmFtZT0iV2hpdGUgQm94Ij4KICAgICAgPHBhdGggaWQ9IlBhdGhfMSIgZGF0YS1uYW1lPSJQYXRoIDEiIGQ9Ik02ODUuMDMyLDUzNS4zNDNoLTk5di01NS4yNWg5OVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01ODUuNTMyIC00NzkuNTkyKSIgZmlsbD0iI2ZmZiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF8yIiBkYXRhLW5hbWU9IlBhdGggMiIgZD0iTTU4Ni41MzIsNDgwLjU5MnY1NC4yNWg5OHYtNTQuMjVoLTk4bS0xLTFoMTAwdjU2LjI1aC0xMDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTg1LjUzMiAtNDc5LjU5MikiIGZpbGw9IiMwMjQiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJHcmV5X0JveCIgZGF0YS1uYW1lPSJHcmV5IEJveCIgZD0iTTU4OS41MzIsNDgzLjU5Mmg5MnY0OC4yNWgtOTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTg1LjUzMiAtNDc5LjU5MikiIGZpbGw9IiMwMjQiLz4KICA8L2c+Cjwvc3ZnPgo=";